import { Theme, Tray } from '@busybusy/webapp-react-ui';
import { DeleteIcon } from 'assets/icons';
import { ActionBar, IconButton } from 'components';
import { t } from 'i18next';

export interface IManageEquipmentCertificationsActionBarProps {
  onDelete: () => void;
  onClear: () => void;
  checkedIds: string[];
}

const ManageEquipmentCertificationsActionBar = (props: IManageEquipmentCertificationsActionBarProps) => {
  const { onDelete, checkedIds, onClear } = props;

  return (
    <>
      <ActionBar selectedCount={checkedIds.length} onClear={onClear}>
        <Tray spacing={1}>
          <IconButton svg={DeleteIcon} onClick={onDelete} tooltipLabel={t('Delete')} theme={Theme.DARK} />
        </Tray>
      </ActionBar>
    </>
  );
};

export default ManageEquipmentCertificationsActionBar;
